module.exports = __webpack_public_path__ + "static/banner.partner-caf8d559adc8f7a85f3b423cfd02a26c.png";